import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';
import { format } from 'date-fns';

import { StatusChip } from '@/components/Cards/Chips/StatusChip';
import { STATUS_COLORS } from '@/constants/statusColors';

export const getDaysToExpireStyle = (days: number) => {
  if (days < 0) {
    return { label: `Vencido (${days})`, bg: STATUS_COLORS.redBg, color: STATUS_COLORS.red };
  } else if (days <= 30) {
    return {
      label: `${days} días (Próximo)`,
      bg: STATUS_COLORS.yellowBg,
      color: STATUS_COLORS.yellow,
    };
  } else {
    return { label: `${days} días`, bg: STATUS_COLORS.greenBg, color: STATUS_COLORS.green };
  }
};

export const batchesColumns = (): Array<GridColDef> => [
  {
    field: 'lotName',
    flex: 1.2,
    headerName: 'Nº de lote',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
        <Typography
          variant="body2"
          sx={{
            color: (theme) => theme.palette.grey[600],
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {params.row.lotName}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'productName',
    flex: 1.5,
    headerName: 'Producto',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        sx={{ py: '0.5rem' }}
      >
        <Typography
          variant="body2"
          sx={{
            color: (theme) => theme.palette.text.primary,
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {params.row.productName}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: (theme) => theme.palette.grey[500],
            textAlign: 'center',
          }}
        >
          SKU: {params.row.sku}
        </Typography>
        {params.row.internalSku && (
          <Typography
            variant="caption"
            sx={{
              color: (theme) => theme.palette.grey[500],
              textAlign: 'center',
            }}
          >
            Int: {params.row.internalSku}
          </Typography>
        )}
      </Box>
    ),
  },
  {
    field: 'quantity',
    flex: 1.3,
    headerName: 'Cantidad',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        sx={{ py: '0.5rem' }}
      >
        <Typography
          variant="caption"
          sx={{
            color: (theme) => theme.palette.text.primary,
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          Disponibilidad: {params.row.onHand ?? 0}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: (theme) => theme.palette.grey[600],
            textAlign: 'center',
          }}
        >
          Entradas: {params.row.quantityIn ?? 0}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: (theme) => theme.palette.grey[600],
            textAlign: 'center',
          }}
        >
          Salidas: {params.row.quantityOut ?? 0}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'receivedAt',
    flex: 1.1,
    headerName: 'Fecha de recepción',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
        <Typography
          variant="body2"
          sx={{
            color: (theme) => theme.palette.grey[600],
            textAlign: 'center',
          }}
        >
          {params.row.receivedAt ? format(new Date(params.row.receivedAt), 'dd/MM/yyyy') : 'N/A'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'expiresAt',
    flex: 1.1,
    headerName: 'Fecha de vencimiento',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
        <Typography
          variant="body2"
          sx={{
            color: (theme) => theme.palette.grey[600],
            textAlign: 'center',
          }}
        >
          {params.row.expiresAt ? format(new Date(params.row.expiresAt), 'dd/MM/yyyy') : 'N/A'}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'daysToExpire',
    flex: 1.2,
    headerName: 'Días por vencer',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => {
      const style = getDaysToExpireStyle(params.row.daysToExpire);
      return (
        <Box display="flex" justifyContent="center" alignItems="center" width="100%" height="100%">
          <StatusChip status={style.label} bg={style.bg} color={style.color} />
        </Box>
      );
    },
  },
];
